import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1.99902C6.477 1.99902 2 6.50402 2 12.061C2 17.082 5.657 21.245 10.438 21.999V14.969H7.898V12.061H10.438V9.84402C10.438 7.32202 11.93 5.93002 14.214 5.93002C15.309 5.93002 16.453 6.12602 16.453 6.12602V8.60302H15.192C13.95 8.60302 13.562 9.37802 13.562 10.173V12.061H16.336L15.893 14.969H13.562V21.999C18.343 21.245 22 17.082 22 12.061C22 6.50402 17.523 1.99902 12 1.99902Z", clipRule: "evenodd" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconSocialFacebook = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconSocialFacebook.displayName = "IconSocialFacebook";

export { IconSocialFacebook };
